angular.module('ihestiaWidgets.policyOperations')
  .controller('vehiclePurchaseSettlementDataCtrl', ['$scope',
    function($scope) {

      //mamy elementy dotyczące rozliczenia, ale na pewno jeszcze nie mamy taryfikacji
      $scope.earlySettlement = true;

      $scope.init = lsnNg.noop;
    }
  ]);